<div class="error-page">
    <div class="item__description">{{description}}</div>
    <button class="btn btn--orange" (click)="navigateBack()">
        U redu
    </button>
</div>